'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import Button from '../Button/index.js';
import Switcher from '../Switcher/index.js';
import closeIcon from '../Dialog/deleteIcon.js';
import styles from './JobAlert.module.scss.js';
import Dialog from '../Dialog/index.js';
import JobTitle from './JobTitle/index.js';
import JobLevel from './JobLevel/index.js';
import JobAlertSelect from './JobAlertSelect/index.js';
import NotificationBy from './NotificationBy/index.js';
import Interval from './Interval/index.js';
import { ESalaryPeriod, SalaryPeriodOptions, successCode, duplicatedJobAlert, maxJobTitleLength } from './constants.js';
import { showToast, TOAST_TYPE_ERROR } from '../Toast/index.js';
import { jobAlertService } from './apiServices.js';
import { t } from '../Utils/helpers.js';
import IconLoading from '../icons/IconLoading.js';
import Input from '../Input/index.js';
import { ELanguage } from '../Utils/constants.js';
import CompanyIndustry from '../CompanyIndustry/index.js';
import JobFunction from '../JobFunction/index.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import '../UploadResumeModal/type.js';
import InputSalary from '../InputSalary/index.js';
import MultipleRadio from '../MultipleRadio/index.js';
import '../Images/AddIcon/index.js';
import '../Images/AddOutlinedIcon/index.js';
import Trash from '../Images/Trash/index.js';
import '../Images/Pencil/index.js';
import '../Images/ArrowRoundedLeft/index.js';
import '../Images/ArrowRoundedRight/index.js';
import '../Images/AwardsIcon/index.js';
import '../Images/BonusIcon/index.js';
import '../Images/CanteenIcon/index.js';
import '../Images/CheckTagIcon/index.js';
import '../Images/CommercialIcon/index.js';
import '../Images/CompanySizeIcon/index.js';
import '../Images/ContactIcon/index.js';
import '../Images/CopyIcon/index.js';
import '../Images/DefaultAvatar/index.js';
import '../Images/DangerIcon/index.js';
import '../Images/ExternalLinkIcon/index.js';
import '../Images/FacebookIcon/index.js';
import '../Images/ForwardIcon/index.js';
import '../Images/HealthcarePlanIcon/index.js';
import '../Images/HeartIcon/index.js';
import '../Images/HeartOutlineIcon/index.js';
import '../Images/HideIcon/index.js';
import '../Images/KindergartenIcon/index.js';
import '../Images/LaptopIcon/index.js';
import '../Images/LibraryIcon/index.js';
import '../Images/LinkIcon/index.js';
import '../Images/LinkedInIcon/index.js';
import '../Images/LoadingCircleIcon/index.js';
import '../Images/MarkerIcon/index.js';
import '../Images/MobileIcon/index.js';
import '../Images/PaidLeaveIcon/index.js';
import '../Images/SearchIcon/index.js';
import '../Images/ShareIcon/index.js';
import '../Images/ReportIcon/index.js';
import '../Images/StatsIcon/index.js';
import '../Images/TeamActivitiesIcon/index.js';
import '../Images/ThreeDotIcon/index.js';
import '../Images/TrainingIcon/index.js';
import '../Images/TransportationIcon/index.js';
import '../Images/TrashIcon/index.js';
import '../Images/TravelOpportunitiesIcon/index.js';
import '../Colors/index.js';
import '../Images/VerticalMoreIcon/index.js';
import '../Images/VoucherIcon/index.js';
import '../Images/WowCVIcon/index.js';
import '../Images/WorkingLocationIcon/index.js';
import '../Images/ZaloIcon/index.js';
import '../Images/FacebookLogoIcon/index.js';
import '../Images/GoogleLogoIcon/index.js';
import '../Images/DragReorderIcon/index.js';
import '../Images/CheckIcon/index.js';
import '../Images/CircleChecked/index.js';
import '../Images/SalaryIcon/index.js';
import '../Images/BriefcaseIcon/index.js';
import '../Images/GraduationCapIcon/index.js';
import '../Images/EnvelopeIcon/index.js';
import '../Images/AddFilledIcon/index.js';
import '../Images/HomeIcon/index.js';
import '../Images/PhoneIcon/index.js';
import '../Images/AttachIcon/index.js';
import '../Images/FilterIcon/index.js';
import '../icons/WarnIcon.js';
import '../icons/AccountSettingsIcon.js';
import '../icons/DashboardIcon.js';
import '../icons/JobAlertsIcon.js';
import '../icons/MyCompaniesIcon.js';
import '../icons/MyJobsIcon.js';
import '../icons/MyProfileIcon.js';
import '../icons/ProfileSettingsIcon.js';
import '../icons/LanguageIcon.js';
import '../icons/BenefitGroupIcons/ActivityIcon.js';
import '../icons/BenefitGroupIcons/AwardsIcon.js';
import '../icons/BenefitGroupIcons/BonusIcon.js';
import '../icons/BenefitGroupIcons/CanteenIcon.js';
import '../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../icons/BenefitGroupIcons/LaptopIcon.js';
import '../icons/BenefitGroupIcons/LibraryIcon.js';
import '../icons/BenefitGroupIcons/MoreIcon.js';
import '../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../icons/BenefitGroupIcons/PhoneIcon.js';
import '../icons/BenefitGroupIcons/TrainingIcon.js';
import '../icons/BenefitGroupIcons/TransportationIcon.js';
import '../icons/BenefitGroupIcons/TravelIcon.js';
import '../icons/BenefitGroupIcons/VoucherIcon.js';
import '../icons/BenefitGroupIcons/Physics.js';
import '../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../icons/AccountCenterGroupIcons/Language.js';
import '../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../icons/AccountCenterGroupIcons/Lawyer.js';
import '../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../icons/InfoOverviewGroupIcons/Location.js';
import '../icons/InfoOverviewGroupIcons/Education.js';
import '../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/Admin.js';
import '../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../icons/InfoOverviewGroupIcons/Address.js';
import '../icons/InfoOverviewGroupIcons/Salary.js';
import '../icons/InfoOverviewGroupIcons/Gender.js';
import '../icons/InfoOverviewGroupIcons/Translator.js';
import '../icons/InfoOverviewGroupIcons/Birthday.js';
import '../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../icons/MiscGroupIcons/Link.js';
import '../icons/MiscGroupIcons/History.js';
import '../icons/MiscGroupIcons/Favorite.js';
import '../icons/MiscGroupIcons/UnFavorite.js';
import '../icons/MiscGroupIcons/ProductDocuments.js';
import '../icons/MiscGroupIcons/Star.js';
import '../icons/SocialMediaGroupIcons/Facebook.js';
import '../icons/SocialMediaGroupIcons/Linkedin.js';
import '../icons/SocialMediaGroupIcons/Twitter.js';
import '../icons/SocialMediaGroupIcons/Zalo.js';
import '../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../icons/SocialMediaGroupIcons/Share.js';
import '../icons/NavigationGroupIcons/Vertical.js';
import '../icons/NavigationGroupIcons/More.js';
import '../icons/NavigationGroupIcons/Close.js';
import '../icons/NavigationGroupIcons/Expand.js';
import '../icons/NavigationGroupIcons/Collapse.js';
import '../icons/NavigationGroupIcons/Next.js';
import '../icons/NavigationGroupIcons/Back.js';
import '../icons/NavigationGroupIcons/ExternalLink.js';
import '../icons/NavigationGroupIcons/RightArrow.js';
import '../icons/AlertGroupIcons/SuccessIcon.js';
import '../icons/AlertGroupIcons/CareerPath.js';
import '../icons/AlertGroupIcons/Hot.js';
import '../icons/AlertGroupIcons/Urgent.js';
import '../icons/FormActionGroupIcons/Exchange.js';
import '../icons/FormActionGroupIcons/AddTag.js';
import '../icons/RewardsTypeGroupIcons/Hospital.js';
import '../Images/DoubleTickIcon/index.js';
import '../Images/BellIcon/index.js';
import '../Images/AiIcon/index.js';
import '../Images/MiniAiIcon/index.js';
import '../icons/OrderManagementIcon.js';
import '../Images/TwinkleLinearGradientIcon/index.js';

var EMPTY_JOB_ALERT_ID = -1;
/**
 * Job Alert Modal Component
 *
 * @param props
 */
var JobAlert = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = props.id, id = _p === void 0 ? '' : _p, _q = props.title, title = _q === void 0 ? 'Create Job Alert' : _q, _r = props.isOpen, isOpen = _r === void 0 ? false : _r, _s = props.isMobile, isMobile = _s === void 0 ? false : _s, _t = props.jobAlertInfo, jobAlertInfo = _t === void 0 ? null : _t, _u = props.jobLocationOptions, jobLocationOptions = _u === void 0 ? [] : _u, _v = props.jobFunctionOptions, jobFunctionOptions = _v === void 0 ? {
        parent: [],
        child: {}
    } : _v, _w = props.jobIndustryOptions, jobIndustryOptions = _w === void 0 ? [] : _w, _x = props.apiTokenAccess, apiTokenAccess = _x === void 0 ? '' : _x, _y = props.apiJobAlert, apiJobAlert = _y === void 0 ? 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts' : _y, _z = props.apiGetJobLevelList, apiGetJobLevelList = _z === void 0 ? 'https://ms.vietnamworks.com/meta/v1.0/job-levels' : _z, _0 = props.msBaseUrl, msBaseUrl = _0 === void 0 ? 'https://ms.vietnamworks.com' : _0, apiJobAlertAnonymous = props.apiJobAlertAnonymous, _1 = props.language, language = _1 === void 0 ? 'vi' : _1, onToggleChange = props.onToggleChange, onDeleteJobAlert = props.onDeleteJobAlert, onAddEditJobAlert = props.onAddEditJobAlert, onClose = props.onClose;
    var isLoggedInProp = props.isLoggedIn;
    var _2 = useState(isOpen !== null && isOpen !== void 0 ? isOpen : false), isModalOpen = _2[0], setIsModalOpen = _2[1];
    var _3 = useState(isLoggedInProp !== null && isLoggedInProp !== void 0 ? isLoggedInProp : true), isLoggedIn = _3[0], setIsLoggedIn = _3[1];
    var jobCategory = (_a = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobCategory) !== null && _a !== void 0 ? _a : [];
    // Job Alert info
    var _4 = useState((_b = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobTitle) !== null && _b !== void 0 ? _b : ''), jobTitle = _4[0], setJobTitle = _4[1];
    var _5 = useState((_c = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobSalary) !== null && _c !== void 0 ? _c : 0), jobSalary = _5[0], setJobSalary = _5[1];
    var _6 = useState((_d = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobLevel) !== null && _d !== void 0 ? _d : []), jobLevel = _6[0], setJobLevel = _6[1];
    var _7 = useState((_e = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobLocation) !== null && _e !== void 0 ? _e : []), jobLocation = _7[0], setJobLocation = _7[1];
    var _8 = useState((_f = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobFunction) !== null && _f !== void 0 ? _f : []), jobFunction = _8[0], setJobFunction = _8[1];
    var _9 = useState((_g = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobIndustry) !== null && _g !== void 0 ? _g : []), jobIndustry = _9[0], setJobIndustry = _9[1];
    var _10 = useState((_h = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.isReceivedJobAlert) !== null && _h !== void 0 ? _h : true), isReceivedJobAlert = _10[0], setReceivedJobAlert = _10[1];
    var _11 = useState((_j = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobInterval) !== null && _j !== void 0 ? _j : 2), jobInterval = _11[0], setJobInterval = _11[1];
    var _12 = useState((_k = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobNotificationBy) !== null && _k !== void 0 ? _k : 1), jobNotificationBy = _12[0], setJobNotificationBy = _12[1];
    var _13 = useState((_l = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.userEmail) !== null && _l !== void 0 ? _l : ''), userEmail = _13[0], setUserEmail = _13[1];
    var _14 = useState((_m = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryCurrencyId) !== null && _m !== void 0 ? _m : 1), salaryCurrencyId = _14[0], setSalaryCurrencyId = _14[1];
    var _15 = useState((_o = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryPeriodId) !== null && _o !== void 0 ? _o : ESalaryPeriod.MONTHLY), salaryPeriodId = _15[0], setSalaryPeriodId = _15[1];
    var _16 = useState(true), isEmailValid = _16[0], setEmailValid = _16[1];
    var _17 = useState(false), shortForm = _17[0], setShortForm = _17[1];
    // modal
    var _18 = useState(false), isShowLoading = _18[0], setShowLoading = _18[1];
    var _19 = useState(false), isDeleteConfirmOpen = _19[0], setDeleteConfirmOpen = _19[1];
    var _20 = useState(false), isAskCloseWithoutSave = _20[0], setAskCloseWithoutSaveOpen = _20[1];
    var _21 = useState(false), isFormChanged = _21[0], setIsFormChange = _21[1];
    var _22 = useState({
        jobTitle: true
    }), validateForm = _22[0], setValidateForm = _22[1];
    // job level list
    var _23 = useState([]), jobLevelList = _23[0], setJobLevelList = _23[1];
    var isEdit = (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== undefined && (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== null;
    var tracking = useHog().tracking;
    useEffect(function () {
        var currentPage = window.location.href;
        setShortForm(currentPage.indexOf('/viec-lam') > 0 || currentPage.indexOf('/jobs') > 0 || currentPage.indexOf('/tim-viec-lam/tim-tat-ca-viec-lam') > 0 || currentPage.indexOf('/job-search/all-jobs') > 0);
    }, []);
    useEffect(function () {
        // Detect Dialog show/hide and pass that value to callback function
        onToggleChange && onToggleChange(isModalOpen);
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isModalOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [isModalOpen]);
    useEffect(function () {
        // Do get Job Level
        var doGetJobLevelList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var getJobLevelListRespone, returnJobLevelList_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (jobLevelList.length > 0) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, jobAlertService.getJobLevelList(apiGetJobLevelList || '')];
                    case 1:
                        getJobLevelListRespone = _a.sent();
                        if (getJobLevelListRespone.data !== undefined &&
                            getJobLevelListRespone.data.relationships !== undefined &&
                            getJobLevelListRespone.data.relationships.data !== undefined) {
                            returnJobLevelList_1 = [];
                            getJobLevelListRespone.data.relationships.data.map(function (item) {
                                returnJobLevelList_1.push({
                                    id: item.id,
                                    text: language === 'en' ? item.attributes.nameEn : item.attributes.nameVi
                                });
                            });
                            setJobLevelList(returnJobLevelList_1);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (isLoggedIn) {
            doGetJobLevelList();
        }
    }, [isLoggedIn]);
    var handleOnClickClose = function () {
        // check if any data new then show ask close popup,
        // if don't have anything new then just close main modal
        if (isFormChanged) {
            setAskCloseWithoutSaveOpen(true);
        }
        else {
            setIsModalOpen(false);
            onClose && onClose();
        }
    };
    var isFormValidate = function () {
        var result = true;
        var jobTitleValid = true;
        // check job title
        if (jobTitle === '' || jobTitle.length > maxJobTitleLength) {
            result = false;
            jobTitleValid = false;
        }
        setValidateForm({
            jobTitle: jobTitleValid
        });
        return result;
    };
    var handleOnClickSaveUserEmail = function () {
        // check email valid
        var isValid = false;
        if (userEmail.indexOf('@') > 0) {
            isValid = true;
            if (userEmail.indexOf('.') > 0) {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        if (isValid) {
            // Done input email for user who didn't log in
            setIsLoggedIn(true);
        }
        else {
            // only set valid false. No need to set true for better performance
            setEmailValid(false);
        }
    };
    var handleOnClickDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var jobAlertResult, isDeleted, deletedNotifyContent;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, jobAlertService.deleteJobAlert("".concat(apiJobAlert).concat(jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId), "".concat(apiTokenAccess))];
                case 1:
                    jobAlertResult = _b.sent();
                    isDeleted = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode) {
                        isDeleted = true;
                        // Hide confirm delete dialog
                        setDeleteConfirmOpen(false);
                        // close edit modal
                        setIsModalOpen(false);
                        deletedNotifyContent = t('Job alert "{0}" deleted', language);
                        showToast(t('Job alert deleted successfully', language), deletedNotifyContent.replace('{0}', jobTitle));
                    }
                    onDeleteJobAlert && onDeleteJobAlert(isDeleted);
                    return [3 /*break*/, 3];
                case 2:
                    _b.sent();
                    setDeleteConfirmOpen(false);
                    showToast(t('Job alert error', language), t("Can't delete this job alert", language), TOAST_TYPE_ERROR);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var postData, isAnonymous, apiUrl, jobAlertResult, isSuccess, notifyTitle, notifyContent, notifyTitle, notifyContent;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    postData = {
                        keyword: jobTitle,
                        salary_min: jobSalary,
                        job_level: jobLevel,
                        location: jobLocation,
                        industry: jobCategory,
                        status: isReceivedJobAlert ? 1 : 0,
                        period_type_id: jobInterval,
                        notification_by: jobNotificationBy,
                        user_email: userEmail,
                        language_id: language === 'en' ? 2 : 1,
                        company_industry: jobIndustry,
                        job_function: jobFunction.map(function (item) { return item.childrenIds[0]; }),
                        salaryPeriodId: salaryPeriodId,
                        salaryCurrencyId: salaryCurrencyId
                    };
                    // Check form valid
                    if (!isFormValidate())
                        return [2 /*return*/];
                    setShowLoading(true);
                    isAnonymous = false;
                    apiUrl = isEdit ? (apiJobAlert || '') + (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) : apiJobAlert;
                    if (isLoggedInProp !== undefined && !isLoggedInProp) {
                        // If user is not logged in then using anonymous url
                        apiUrl = apiJobAlertAnonymous || '';
                        if (jobLevel.length > 0) {
                            postData.job_level_id = jobLevel[0];
                        }
                        isAnonymous = true;
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, jobAlertService.createEditJobAlert(postData, isEdit, "".concat(apiUrl), "".concat(apiTokenAccess), isAnonymous)];
                case 2:
                    jobAlertResult = _e.sent();
                    isSuccess = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode || (jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        tracking({
                            eventName: 'js_job_management:job_alert_create',
                            properties: {
                                keyword: jobTitle,
                                frequencyId: jobInterval,
                                chanelId: jobNotificationBy,
                                isEnable: !!isReceivedJobAlert,
                                isAnonymous: isAnonymous
                            }
                        });
                    }
                    if (((_b = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _b === void 0 ? void 0 : _b.code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = t('Job alert created successfully', language);
                        notifyContent = t('Job alert "{0}" created', language);
                        if (isEdit) {
                            // show edit success
                            notifyTitle = t('Job alert updated successfully', language);
                            notifyContent = t('Job alert "{0}" updated', language);
                        }
                        showToast(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = t('Job alert created successfully', language);
                        notifyContent = t('Job alert "{0}" created', language);
                        showToast(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === duplicatedJobAlert) {
                        isSuccess = false;
                        // show duplicate
                        showToast(t('Job alert error', language), t('You already created this job alert', language), TOAST_TYPE_ERROR);
                    }
                    setShowLoading(false);
                    onAddEditJobAlert && onAddEditJobAlert(isSuccess, (_d = (_c = jobAlertResult.data) === null || _c === void 0 ? void 0 : _c.job_alert_id) !== null && _d !== void 0 ? _d : EMPTY_JOB_ALERT_ID);
                    return [3 /*break*/, 4];
                case 3:
                    _e.sent();
                    setShowLoading(false);
                    showToast(t('Job alert error', language), t("Can't update this job alert", language), TOAST_TYPE_ERROR);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickCloseAskSave = function () {
        setAskCloseWithoutSaveOpen(false);
        setIsModalOpen(false);
        onClose && onClose();
    };
    var isShowJobAlertModal = isModalOpen;
    if (isAskCloseWithoutSave) {
        isShowJobAlertModal = false;
    }
    if (isDeleteConfirmOpen) {
        isShowJobAlertModal = false;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "".concat(styles.backdrop + ' ' + (isShowJobAlertModal ? styles.isOpen : '')), onClick: handleOnClickClose }),
        React__default.createElement("div", { className: "".concat('box-dialog ' + styles.jobAlertModal + ' ' + (isShowJobAlertModal ? styles.isOpen : ''), " ").concat(shortForm ? styles.shortFormModal : "") },
            React__default.createElement("div", { className: styles.overlayLock, style: { display: isShowLoading ? 'flex' : 'none' } },
                React__default.createElement(IconLoading, { width: 64, height: 64 })),
            React__default.createElement("div", { className: shortForm ? "".concat(styles.borderWrapHeader, " ").concat(styles.header) : styles.header },
                React__default.createElement("div", { className: styles.modalTitle }, t(title || 'Job alert', language)),
                React__default.createElement("span", { onClick: handleOnClickClose, className: "".concat(styles.icon, " ").concat(isMobile ? styles.left : styles.right) },
                    React__default.createElement(closeIcon, null))),
            isLoggedIn ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: styles.body },
                    isMobile && !shortForm ? (React__default.createElement("div", { className: styles.row },
                        React__default.createElement("div", { className: styles.colSmall12 },
                            React__default.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                    setReceivedJobAlert(value);
                                    if (value !== isReceivedJobAlert)
                                        setIsFormChange(true);
                                }, value: isReceivedJobAlert, label: t('Receive Job Alerts', language) })))) : (React__default.createElement(React__default.Fragment, null)),
                    shortForm ? (React__default.createElement("div", { className: styles.row },
                        React__default.createElement("p", { className: styles.shortFormText }, t("Create a job alert to seize a new opportunity. Don't miss the opportunity to find your dream job", language)),
                        React__default.createElement("div", { className: styles.jobAlertBanner },
                            React__default.createElement("img", { src: 'https://images.vietnamworks.com/images/banner_job_alert.png', alt: '' })))) : null,
                    React__default.createElement("div", { className: "".concat(styles.row + ' ' + styles.mb0, " ").concat(shortForm ? "".concat(styles.borderWrap) : "") },
                        React__default.createElement("div", { className: isMobile || shortForm ? styles.colSmall6 : styles.row },
                            React__default.createElement(JobTitle, { key: "jobTitle-".concat(validateForm.jobTitle ? 'true' : 'false'), jobTitle: jobTitle, setJobTitle: function (value) {
                                    setJobTitle(value);
                                    if (value !== jobTitle)
                                        setIsFormChange(true);
                                }, isValidate: validateForm.jobTitle, language: language, shortForm: shortForm })),
                        !shortForm ? (React__default.createElement("div", { className: isMobile ? '' : styles.row },
                            React__default.createElement("div", { className: styles.colSmall6 + ' ' + styles.inputSalary },
                                React__default.createElement(InputSalary, { salary: jobSalary, currencyId: salaryCurrencyId, msBaseUrl: msBaseUrl, langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN, options: {
                                        label: t('Salary from', language)
                                    }, onChange: function (value, currencyId) {
                                        setJobSalary(value);
                                        setSalaryCurrencyId(currencyId);
                                        if (value !== jobSalary)
                                            setIsFormChange(true);
                                    }, isMobile: isMobile })),
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement("label", { htmlFor: 'jobSalary' }, t('Pay period', language)),
                                React__default.createElement(MultipleRadio, { name: 'currencyPeriod', value: salaryPeriodId, options: language === 'vi' ? SalaryPeriodOptions.vi : SalaryPeriodOptions.en, onChange: function (_a) {
                                        var value = _a.value;
                                        setSalaryPeriodId(value);
                                    }, isMobile: isMobile })))) : (React__default.createElement("div", { className: styles.colSmall6 },
                            React__default.createElement(JobAlertSelect, { isMobile: isMobile, jobSelectValue: jobLocation, setJobSelect: function (id) {
                                    setJobLocation(id);
                                    if (id !== jobLocation)
                                        setIsFormChange(true);
                                }, title: t('Expected working location', language), jobOptions: jobLocationOptions, limitAlertText: t('You can only choose maximum 3 locations', language), errorText: t('This field is required', language), noResult: t('No result', language), pleaseSelect: t('Select location', language), limitCharacterShow: 120, customWidth: '100%', langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN })))),
                    !shortForm ? (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("div", { className: styles.row },
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement(JobLevel, { isMobile: isMobile, jobLevelOptions: jobLevelList, jobLevel: jobLevel, setJobLevel: function (value) {
                                        setJobLevel(value);
                                        if (value !== jobLevel)
                                            setIsFormChange(true);
                                    }, language: language === 'vi' ? ELanguage.VI : ELanguage.EN, limitCharacterShow: 120, limitMaxShowItem: 3 })),
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement(JobAlertSelect, { isMobile: isMobile, jobSelectValue: jobLocation, setJobSelect: function (id) {
                                        setJobLocation(id);
                                        if (id !== jobLocation)
                                            setIsFormChange(true);
                                    }, title: t('Location', language), jobOptions: jobLocationOptions, limitAlertText: t('You can only choose maximum 3 locations', language), errorText: t('This field is required', language), noResult: t('No result', language), pleaseSelect: t('Select location', language), limitCharacterShow: 120, customWidth: '100%', langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN }))),
                        React__default.createElement("div", { className: styles.row },
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement(React__default.Fragment, null,
                                    React__default.createElement("label", null, language === ELanguage.VI ? 'Ngành nghề' : 'Job function'),
                                    React__default.createElement(JobFunction, { isMobile: isMobile, data: jobFunctionOptions, value: jobFunction, langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN, onChange: function (value) {
                                            setJobFunction(value);
                                            setIsFormChange(true);
                                        }, dropdownStyleOptions: {
                                            width: '100%'
                                        }, isFlex: true, textOptions: {
                                            placeholder: t('Select job function', language)
                                        }, isSingleSelect: true, displayAsPopup: true }))),
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement("label", { htmlFor: 'userEmail' }, language === ELanguage.VI ? 'Lĩnh vực công ty' : 'Industry'),
                                React__default.createElement(CompanyIndustry, { type: 'multiple-select', options: jobIndustryOptions, value: jobIndustry, onChange: function (ids) {
                                        setJobIndustry(ids);
                                        setIsFormChange(true);
                                    }, langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN, dropdownStyle: { width: '100%' }, isMobile: isMobile }))),
                        React__default.createElement("div", { className: styles.row },
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement(Interval, { alertId: id, jobInterval: jobInterval, setJobInterval: function (value) {
                                        setJobInterval(value);
                                        if (value !== jobInterval)
                                            setIsFormChange(true);
                                    }, language: language })),
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement(NotificationBy, { alertId: id, jobNotificationBy: jobNotificationBy, setJobNotificationBy: function (value) {
                                        setJobNotificationBy(value);
                                        if (value !== jobNotificationBy)
                                            setIsFormChange(true);
                                    }, language: language }))))) : null),
                React__default.createElement("div", { className: "".concat(styles.footer, " ").concat(shortForm ? "".concat(styles.borderWrapFooter) : "") },
                    React__default.createElement("div", { className: "".concat(styles.row + ' ' + styles.flexCenter, " ").concat(shortForm ? "".concat(styles.borderWrapBetween) : "") },
                        !shortForm ? (React__default.createElement("div", { className: styles.colSmall6 + ' ' + styles.alignMiddle + ' ' + styles.hideOnMobile }, isMobile ? (React__default.createElement("div", null)) : (React__default.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                setReceivedJobAlert(value);
                                if (value !== isReceivedJobAlert)
                                    setIsFormChange(true);
                            }, value: isReceivedJobAlert, label: t('Receive Job Alerts', language) })))) : (React__default.createElement("div", null,
                            React__default.createElement("span", { className: "".concat(styles.textBlue), onClick: function () { return setShortForm(false); } },
                                React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', style: { marginRight: '10px' } },
                                    React__default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.00034 9.99993C2.00034 5.58961 5.59002 1.99992 10.0003 1.99992C14.4106 1.99992 18.0003 5.58961 18.0003 9.99993C18.0003 14.4102 14.4106 17.9999 10.0003 17.9999C5.59002 17.9999 2.00034 14.4102 2.00034 9.99993ZM16.667 9.99993C16.667 6.31023 13.69 3.33326 10.0003 3.33326C6.31065 3.33326 3.33367 6.31023 3.33367 9.99993C3.33367 13.6896 6.31065 16.6666 10.0003 16.6666C13.69 16.6666 16.667 13.6896 16.667 9.99993ZM10.6675 10.6667H13.3342C13.7022 10.6667 14.0009 10.3687 14.0009 10C14.0009 9.63133 13.7022 9.33333 13.3342 9.33333H10.6675V6.66666C10.6675 6.298 10.3689 6 10.0009 6C9.63285 6 9.33418 6.298 9.33418 6.66666V9.33333H6.66752C6.29952 9.33333 6.00085 9.63133 6.00085 10C6.00085 10.3687 6.29952 10.6667 6.66752 10.6667H9.33418V13.3333C9.33418 13.702 9.63285 14 10.0009 14C10.3689 14 10.6675 13.702 10.6675 13.3333V10.6667Z', fill: '#005AFF' })),
                                t('Add more criteria', language)))),
                        React__default.createElement("div", { className: "".concat(styles.colSmall6, " ").concat(styles.colBottomRight) },
                            isEdit ? (React__default.createElement("div", { className: styles.iconDelete, onClick: function () { return setDeleteConfirmOpen(true); } },
                                React__default.createElement(Trash, { width: 24, height: 24 }))) : (React__default.createElement("div", null)),
                            React__default.createElement("div", null,
                                React__default.createElement(Button, { type: 'primary', style: { float: 'right' }, onClick: handleOnClickSave }, t(shortForm ? 'Create alert' : 'Save alert', language)),
                                !shortForm ? (React__default.createElement(Button, { style: { marginRight: 10 }, onClick: handleOnClickClose }, t('Cancel', language))) : null)))))) : (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: styles.body },
                    React__default.createElement("div", { className: styles.row },
                        React__default.createElement("div", { className: styles.colSmall8 },
                            React__default.createElement("label", { htmlFor: 'userEmail' }, t('Your email', language)),
                            React__default.createElement(Input, { type: 'text', id: 'userEmail', isRequired: true, onChange: function (value) {
                                    setEmailValid(true);
                                    setUserEmail(value);
                                }, onPressEnter: handleOnClickSaveUserEmail, value: userEmail, className: styles.jobAlertInput, maxLength: 100, placeholder: t('Email to receive jobs', language), autoFocus: true, hasError: !isEmailValid })),
                        isMobile ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement("div", { className: styles.colSmall4, style: { paddingLeft: 10 } },
                            React__default.createElement(Button, { type: 'primary', size: 'md', onClick: handleOnClickSaveUserEmail, style: { width: '100%' } }, t('Send me jobs', language))))),
                    React__default.createElement("div", __assign({ className: styles.row }, (isEmailValid ? { hidden: true } : '')),
                        React__default.createElement("p", __assign({ className: "error-message ".concat(styles.errorMessage) }, (isEmailValid ? { hidden: true } : '')), t('This is not a valid email address', language)))),
                isMobile ? (React__default.createElement("div", { className: styles.footer },
                    React__default.createElement("div", { className: styles.row + ' ' + styles.flexCenter },
                        React__default.createElement("div", { className: "".concat(styles.colSmall6, " ").concat(styles.colBottomRight) },
                            React__default.createElement("div", null,
                                React__default.createElement(Button, { type: 'primary', size: 'sm', className: 'SJ_SaveSendJob', onClick: handleOnClickSaveUserEmail, style: { float: 'right' } }, t('Send me jobs', language)),
                                React__default.createElement(Button, { size: 'sm', style: { marginRight: 10 }, onClick: handleOnClickClose }, t('Cancel', language))))))) : (React__default.createElement(React__default.Fragment, null))))),
        React__default.createElement(Dialog, { title: t('Delete this Job Alert?', language), isOpen: isDeleteConfirmOpen, onBack: function () { return setDeleteConfirmOpen(false); }, onClickAction: handleOnClickDelete, type: 'delete', deleteText: t('Remove', language), secondaryButtonText: t('Cancel', language), backdrop: true },
            React__default.createElement("div", null, t('You will not be able to receive email for job alert', language))),
        React__default.createElement(Dialog, { title: t('Discard this job alert?', language), isOpen: isAskCloseWithoutSave, onBack: function () { return setAskCloseWithoutSaveOpen(false); }, onClickAction: handleOnClickCloseAskSave, type: 'delete', deleteText: t('Yes', language), secondaryButtonText: t('No', language), backdrop: true },
            React__default.createElement("div", null, t('This job alert will not be saved', language)))));
};

export { JobAlert as default };
//# sourceMappingURL=index.js.map
